import Vue from 'vue'
import App from './App.vue'
import Toast from '@/utils/toast'
Vue.use(Toast)
import router from './router'
import store from './store'
import 'amfe-flexible'
import '@/utils/remCap'

Vue.config.productionTip = false




new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
